import type { DynamicClient } from '../../../client/types';
import { assertDefined } from '../../../utils/assertDefined';
import { getNonce } from '../../../utils/getNonce';
import { isCookieEnabled } from '../../projectSettings/isCookieEnabled';
import { getDeviceSigner } from '../getDeviceSigner';

/** @notInstrumented */
export const getHeadersForNonceSignedByDeviceSigners = async (
  client: DynamicClient
): Promise<Record<string, string>> => {
  const { projectSettings } = client;

  assertDefined(projectSettings, 'Project settings not found');

  /**
   * For cookie based environments, the device registration is handled
   * by settings the cookie in the browser.
   * Then we dont need to provide the headers
   */
  if (isCookieEnabled(client)) {
    return {};
  }

  const deviceSigner = await getDeviceSigner(client);

  const nonce = await getNonce(client);

  const signedNonce = await deviceSigner.sign(nonce);
  const publicKey = await deviceSigner.getPublicKey();

  return {
    'x-dynamic-device-nonce': nonce,
    'x-dynamic-device-publickey': publicKey,
    'x-dynamic-device-signed-nonce': signedNonce,
  };
};
